export default "__VITE_ASSET__DIkluwS2__"